<template>
	<div>
		<div class="row" >
			<div class="subColecao">{{$vnode.key}} - {{subColecao.nome}} </div>
		</div>

		<div class="row" v-for="objeto in subColecao.objetos" :key="objeto.ordem">
			<div class="order">#{{objeto.ordem}}</div>
			<div class="rowCinza">
				<div class="name">{{objeto.titulo}}</div>
				<div class="type">{{objeto.tipoNome}}</div>
				<div class="comment" v-if="objeto.comentario" @click="vizualizarComentario(objeto.comentario)"><i class="fas fa-comments"></i></div>
				<div class="comment" v-else><i class="far fa-comments"></i></div>
			</div>
		</div>

		<hr v-if="subColecao.objetos && subColecao.objetos.length > 0 && subColecoes.length > 0">

		<SubColecoes v-for="(subColecao, index) in subColecoes" :key="$vnode.key + '.' + (index + 1)" :subColecoes="subColecao.subColecoes" :subColecao="subColecao" />

	</div>
</template>
<script>
import SubColecoes from './SubColecoes'
import EventBus from '@/components/event-bus.js'
export default {
	name: 'SubColecoes',
	components: { SubColecoes },
	props: ['subColecoes', 'subColecao'],
	methods: {
		adicionarSubArea (id) {
			const payLoad = { id }
			EventBus.$emit('salvar-area', payLoad)

			EventBus.$on('reposta-cadastro-area', async () => {
				this.showChildren = !this.showChildren
				this.isOpen = true
			})
		},
		vizualizarComentario (comentario) {
			const payLoad = { comentario }
			EventBus.$emit('visualizar-comentario', payLoad)
		}
	}
}
</script>
<style lang="scss" scoped>
.tree-menu {
	background-color: #F3F7FC;
	table {
		margin-bottom: 5px;
		tbody{
			tr {
				padding: 5px;
				td {
					padding-top: 4px;
					padding-bottom: 4px;
					button {
						display: flex;
						align-items: center;
						height: 30px;
						margin-right: 5px;
						margin-bottom: 6px;
						color: #fff;
					}
				}
				td:nth-child(1) {
					padding-left: 5px;
					color: #fff;
					margin: 5px;
					i {
							background-color: $main-color;
							font-size: 13px;
							height: 20px;
							width: 25px;
							display: flex;
							justify-content: center;
							align-items: center;
							margin-right: 3px;
					}
				}
			}
		}
	}
	.tree-menu {
		table {
			margin-bottom: 5px;
			tbody{
				tr {
					border-radius: 4px;
					background-color: #d7dee6;
					td {
						padding-top: 4px;
						padding-bottom: 4px;
						button {
							display: flex;
							align-items: center;
							height: 30px;
							margin-bottom: 3px;
						}
					}
					td:nth-child(1) {
						width: 900px;
					}
				}
			}
		}
	}
}

.row {
	display: flex;
	margin-bottom: 15px;
	align-items: center;

	.subColecao {
		background-color: #fff;
		flex-grow: 0;
		margin-right: 10px;
		font: Condensed Bold 18px/24px Roboto;
		color: #59708F;
		text-transform: uppercase;
	}
	.order {
		background-color: #fff;
		flex-grow: 0;
		margin-right: 10px;
		font: Condensed Bold 20px/26px Roboto;
		color: #59708F;
	}
	.rowCinza {
		display:flex;
		padding: 10px;
		background-color: #ebf0f9;
		width: 100%;
		border-radius: 6px;
		.name {
			flex: 5;
		}
		.type {
			flex: 1;
		}
		.comment {
			flex-grow: 0;
			font-size: 25px;
			position: relative;
			span {
				display: inline;
				position: absolute;
				left: -200px;
			}
		}

	}
}
</style>
